import { Box } from "@chakra-ui/react";
import { getImageSrc } from "data/svgData";

import React from "react";

const Index = ({ widget }) => {
  return (
    <Box
      className={`widget-side-div-inner-new${
        widget?.layout === "center" ? "-center" : ""
      }`}
      marginBottom={0}
      style={{
        color: widget?.header_color,
        backgroundColor: widget?.header_background_color,
        borderColor: widget?.header_background_color,
      }}
    >
      {widget?.logo ? (
        <Box width={20}>
          <img
            style={{ borderRadius: "50px" }}
            src={getImageSrc(widget?.logo) || widget?.logo}
            alt="logo"
          />
        </Box>
      ) : (
        ""
      )}
      <Box
        style={{ display: widget?.layout === "center" ? "block" : "" }}
        className={`widget-side-div-inner-text ${
          widget?.layout === "center" ? "center-text" : ""
        }`}
      >
        <Box style={{ fontWeight: 700, fontSize: "2.125rem" }}>
          {widget?.header_title !== "" ? widget?.header_title : "Hello"}
        </Box>
        <Box className="widget-side-div-inner-text2">
          <h3 style={{ fontSize: "1.125rem" }}>
            {widget?.header_subtitle !== ""
              ? widget?.header_subtitle
              : "Ask me something"}
          </h3>
        </Box>
      </Box>
    </Box>
  );
};

export default Index;
